import { ContentPopulate } from './contents';
import { PopupApiDto, PopupEventApiType } from './dto';
import { apiRequest, BaseOptions, getBaseOptions, Populate } from './utils/util';

const rootPath = '/v2/popups';

export interface PopupPopulate {
  content?: Populate<ContentPopulate>;
  offer?: boolean;
}

export interface SessionData {
  previousSessionStartDate?: string;
  productsHistory?: Array<{
    pathname?: string;
    visitedAt: string;
  }>;
  sessionStartDate?: string;
  visitedPagesCount?: number;
}

export interface HandlePopupsOptions extends BaseOptions {
  populate: PopupPopulate;
  sessionData?: SessionData;
}

export const handlePopups = async <T>(
  event: PopupEventApiType,
  url: string,
  popupsToExclude: Array<string>,
  options?: HandlePopupsOptions
) =>
  apiRequest<Array<PopupApiDto<T>>, void, PopupPopulate>({
    ...getBaseOptions(options),
    params: {
      event,
      popupsToExclude,
      url,
    },
    populate: options?.populate,
    staleTime: Infinity,
    url: `${rootPath}`,
  });

export interface GetPopupByIdOptions extends BaseOptions {
  populate: PopupPopulate;
}

export const getPopupById = async <T>(id: string, options?: GetPopupByIdOptions, staleTime = Infinity) =>
  apiRequest<PopupApiDto<T>, void, PopupPopulate>({
    ...getBaseOptions(options),
    populate: options?.populate,
    staleTime,
    url: `${rootPath}/${id}`,
  });
